module.exports = __webpack_public_path__ + "static/media/nba2019.56859ea0.jpg";